<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-playlist`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M29 36a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h22zm6-11.036a1 1 0 01.588.191l8.3 6.036a1 1 0 010 1.618l-8.3 6.036A1 1 0 0134 38.036V25.964a1 1 0 011-1zM29 22a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1v-2a1 1 0 011-1h22zM39 8a1 1 0 011 1v2a1 1 0 01-1 1H7a1 1 0 01-1-1V9a1 1 0 011-1h32z"/></svg>
</template>
<script>

export default {
  name: 'IconPlaylist',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
